import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { PositiveColors } from '@picsart/design-system/foundation/colors';
import { hideScrollbars } from '@picsart/design-system/foundation/styleHelpers';

const useStyles = createUseStyles(
  {
    // @ts-ignore
    '@global': {
      ...hideScrollbars,

      ':root': {
        backgroundColor: PositiveColors.base.default,
      },
    },
    fallbackContainer: {
      position: 'relative',
      padding: [Spacings.s24, Spacings.s40, Spacings.s72],

      '@media screen and (max-width: 768px)': {
        padding: [Spacings.s24, Spacings.s12, Spacings.s72],
      },
    },
  },
  {
    name: 'drive',
  },
);

export default useStyles;
